// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

export abstract class HeaderNames {
    static readonly Authorization = "Authorization";
    static readonly Cookie = "Cookie";
}
